module.exports = __webpack_public_path__ + "assets/70847dc2e3f6372f15e6de531af7cfad.mp3";